import api from './client';

export interface Character {
  id: string;
  name: string;
  avatar_base: number;
  avatar_url: string | null;
  character_type_id: string | null;
  level: number;
  xp: number;
  pending_level_up: number | null;
  is_active: boolean;
  created_at: string;
}

export interface CharacterTypePublic {
  id: string;
  name: string;
  description: string | null;
  avatar_url: string;
  status: 'starter' | 'store' | 'disabled';
  price: number | null;
}

export const listCharacters = async (): Promise<Character[]> => {
  const res = await api.get('/api/characters');
  return res.data;
};

export const createCharacter = async (name: string, character_type_id: string): Promise<Character> => {
  const res = await api.post('/api/characters', { name, character_type_id });
  return res.data;
};

export const activateCharacter = async (id: string): Promise<Character> => {
  const res = await api.put(`/api/characters/${id}/activate`);
  return res.data;
};

export const getActiveCharacter = async (): Promise<Character | null> => {
  const res = await api.get('/api/characters/active');
  return res.data;
};

export const getStarterCharacterTypes = async (): Promise<CharacterTypePublic[]> => {
  const res = await api.get('/api/character-types/starters');
  return res.data;
};

export const startTeamImage = async (): Promise<{ job_id: string; status: string }> => {
  const res = await api.post('/api/characters/team-image');
  return res.data;
};
